import { render } from "./IndependentMode.vue?vue&type=template&id=4989dd8a"
import script from "./IndependentMode.vue?vue&type=script&lang=js"
export * from "./IndependentMode.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__